export function init($name = '') {
    const nav = $($name);

    if (!nav.length) {
        return;
    }

    const activeElem = nav.find('.current_page_item').last();
    const parents = activeElem.parents('li');

    if (!activeElem.length) {
        return;
    }

    if (activeElem.hasClass('menu-item-has-children') || activeElem.hasClass('special-hover-action-careers')) {
        activeElem.addClass('left-support');
        parents.addClass('left-support-parent');
    } else if(parents.length || parents.hasClass('special-hover-action-careers')) {
        parents.each(function(index) {
            if (index === 0) {
                $(this).addClass('left-support');
            } else {
                $(this).addClass('left-support-parent');
            }
        });
    }
}